export const iconFontAwesomeShoppingCreditCard = (
	<i className="fa-solid fa-credit-card"></i>
);
